export default __webpack_public_path__ + "static/media/pixel.7fb1867a.jpeg";